module.exports = __webpack_public_path__ + "static/media/sd-card.fd73676a.svg";